export default "__VITE_ASSET__gktICBdY__"